// Lead source context for Shopify contact-form emails. Store paths, hostnames and a
// channel label only: never retain query strings, click IDs, fragments, email
// addresses or full referrer URLs.
(function () {
  var FIRST_TOUCH_DAYS = 180;

  function safePath(path) {
    if (!path || /@|%40|\/account|\/challenge|\/checkout/i.test(path)) return '';
    return path.slice(0, 180);
  }

  function safeValue(value) {
    return value && /^[a-z0-9 _.-]{1,80}$/i.test(value) ? value : '';
  }

  // One plain-English label per visit, so Joe can read the enquiry email and know
  // where it came from without opening analytics.
  function classify(params, referrerHost, ownHost) {
    var source = (safeValue(params.get('utm_source')) || '').toLowerCase();
    var medium = (safeValue(params.get('utm_medium')) || '').toLowerCase();
    var host = (referrerHost || '').toLowerCase();

    if (/^(chatgpt|chat\.openai|openai)([._ -]|$)/.test(source) || /(^|\.)chatgpt\.com$|(^|\.)chat\.openai\.com$/.test(host)) return 'ChatGPT';
    if (/^perplexity([._ -]|$)/.test(source) || /(^|\.)perplexity\.ai$/.test(host)) return 'Perplexity';
    if (/^gemini([._ -]|$)/.test(source) || host === 'gemini.google.com') return 'Gemini';
    if (/^copilot([._ -]|$)/.test(source) || /(^|\.)copilot\.microsoft\.com$/.test(host)) return 'Copilot';
    if (/^claude([._ -]|$)/.test(source) || /(^|\.)claude\.ai$/.test(host)) return 'Claude';

    var paid = /^(cpc|ppc|paid|paidsocial|paid_social|paid-social|ads?)$/.test(medium);
    if (params.get('gclid') || params.get('gbraid') || params.get('wbraid') || (paid && /^google([._ -]|$)/.test(source))) return 'Google Ads';
    if (paid && /^(facebook|fb|instagram|ig|meta)([._ -]|$)/.test(source)) return 'Meta ads';
    if (paid && /^(bing|microsoft)([._ -]|$)/.test(source)) return 'Microsoft Ads';
    if (params.get('fbclid')) return 'Facebook or Instagram link';
    if (medium === 'email' || /^(klaviyo|mailchimp|newsletter)([._ -]|$)/.test(source)) return 'Email';
    if (source) return 'Tagged: ' + source + (medium ? ' / ' + medium : '');

    if (!host || host === ownHost) return 'Direct or unknown';
    if (/(^|\.)google\.[a-z.]+$/.test(host)) return 'Google organic';
    if (/(^|\.)bing\.com$|(^|\.)yahoo\.com$|(^|\.)duckduckgo\.com$|(^|\.)ecosia\.org$/.test(host)) return 'Bing or Yahoo organic';
    if (/(^|\.)(facebook|instagram)\.com$/.test(host)) return 'Facebook or Instagram';
    if (/(^|\.)gumtree\.com\.au$/.test(host)) return 'Gumtree';
    return 'Referral: ' + host.slice(0, 80);
  }

  try {
    var ownHost = window.location.hostname;
    var params = new URLSearchParams(window.location.search);
    var referrerHost = '';
    if (document.referrer) {
      var referrer = new URL(document.referrer);
      if (referrer.hostname !== ownHost) referrerHost = referrer.hostname.slice(0, 120);
    }

    var sessionKey = 'bms_session_entry_v1';
    var entry;
    var existing = window.sessionStorage.getItem(sessionKey);
    if (existing) {
      entry = JSON.parse(existing);
    } else {
      entry = { landingPath: safePath(window.location.pathname) };
      if (referrerHost) entry.referrerHost = referrerHost;
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (name) {
        var value = safeValue(params.get(name));
        if (value) entry[name] = value;
      });
      entry.channel = classify(params, referrerHost, ownHost);
      window.sessionStorage.setItem(sessionKey, JSON.stringify(entry));
    }

    // First touch survives across visits, because marquee buyers research for days.
    try {
      var firstKey = 'bms_first_touch_v1';
      var first = JSON.parse(window.localStorage.getItem(firstKey) || 'null');
      var maxAge = FIRST_TOUCH_DAYS * 86400000;
      var expired = !first || !first.date || Date.now() - Date.parse(first.date) > maxAge;
      // A first visit we could not attribute is replaced by the first real source we see.
      var upgrade = first && first.channel === 'Direct or unknown' && entry.channel && entry.channel !== 'Direct or unknown';
      if (expired || upgrade) {
        // Visitor's local date (Brisbane for most buyers), not UTC.
        var now = new Date();
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        first = {
          channel: entry.channel || 'Direct or unknown',
          landingPath: entry.landingPath || '',
          date: now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate())
        };
        window.localStorage.setItem(firstKey, JSON.stringify(first));
      }
      entry.firstTouch = first;
    } catch (_) {
      // localStorage blocked: session data still reaches the form.
    }

    window.BMSLeadSource = entry;
  } catch (_) {
    // Storage may be blocked. The contact form must continue to work normally.
  }

  // Add the source as hidden contact[...] fields, so Shopify includes them in the
  // enquiry email. Runs before the theme's own submit handler builds FormData.
  // 8 Oct 2026: also fills the "Ask us first" enquiry forms (data-bms-lead-form), and is exposed
  // as window.BMSFillLeadForm(form) so assets/bms-cro.js can refresh the fields just before an AJAX send.
  function fillContactForm(target) {
    try {
      var forms = target && target.nodeType === 1 ? [target] : Array.prototype.slice.call(document.querySelectorAll('#ContactForm, [data-bms-lead-form]'));
      forms.forEach(fillOne);
    } catch (_) {
      // Never block the enquiry form.
    }
  }

  function fillOne(form) {
    try {
      if (!form) return;
      var entry = window.BMSLeadSource || {};
      var first = entry.firstTouch || {};
      var previous = '';
      try {
        var ref = new URL(document.referrer);
        if (ref.hostname === window.location.hostname) previous = safePath(ref.pathname);
      } catch (_) {}
      var fields = {
        'Source channel': entry.channel,
        'First visit channel': first.channel,
        'First visit landing path': first.landingPath,
        'First visit date': first.date,
        'Session landing path': entry.landingPath,
        'Session referrer host': entry.referrerHost,
        'Previous page path': previous,
        'UTM source': entry.utm_source,
        'UTM medium': entry.utm_medium,
        'UTM campaign': entry.utm_campaign
      };
      Object.keys(fields).forEach(function (label) {
        var name = 'contact[' + label + ']';
        var input = form.querySelector('input[name="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = fields[label] || '';
      });
    } catch (_) {
      // Never block the enquiry form.
    }
  }

  window.BMSFillLeadForm = fillContactForm;

  // 22 Oct 2026 lead form upgrade: one "Lead summary" line at the top of every enquiry email
  // (size | postcode | event date | pickup or delivery | source) plus an "Urgency" flag when the
  // event is close, so Joe can triage from the email without opening it. Runs on submit, before
  // the browser or theme builds the form data. Plain Shopify post is unchanged.
  function val(form, names) {
    for (var i = 0; i < names.length; i++) {
      var el = form.querySelector('[name="contact[' + names[i] + ']"]');
      if (el && el.value && el.value.trim()) return el.value.trim();
    }
    return '';
  }

  function daysUntil(text) {
    if (!text) return null;
    var d = /^\d{4}-\d{2}-\d{2}$/.test(text) ? new Date(text + 'T00:00:00') : new Date(text);
    if (isNaN(d.getTime())) return null;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    return Math.round((d.getTime() - today.getTime()) / 86400000);
  }

  function setHidden(form, label, value, first) {
    var name = 'contact[' + label + ']';
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      if (first && form.firstChild) form.insertBefore(input, form.firstChild); else form.appendChild(input);
    }
    input.value = value;
  }

  function buildSummary(form) {
    try {
      if (!form) return;
      fillOne(form);
      var entry = window.BMSLeadSource || {};
      var size = val(form, ['Marquee size', 'Product']).replace(/\s*\(.*$/, '');
      var pc = val(form, ['Delivery postcode']);
      var date = val(form, ['Event date']);
      var how = val(form, ['Delivery or pickup']);
      var n = daysUntil(date);
      var urgency = '';
      if (n !== null) {
        if (n < 0) urgency = '';
        else if (n <= 14) urgency = 'URGENT: event in ' + n + ' day' + (n === 1 ? '' : 's') + ', reply today';
        else if (n <= 30) urgency = 'SOON: event in ' + n + ' days';
      }
      var parts = [];
      if (urgency.indexOf('URGENT') === 0) parts.push('URGENT');
      if (size) parts.push(size);
      if (pc) parts.push(pc);
      if (date) parts.push(date);
      if (how && how !== 'Not sure yet') parts.push(how);
      parts.push(entry.channel || 'Direct or unknown');
      setHidden(form, 'Lead summary', parts.join(' | '), true);
      setHidden(form, 'Urgency', urgency || 'Normal');
    } catch (_) {
      // Never block the enquiry form.
    }
  }

  window.BMSLeadSummary = buildSummary;

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('#ContactForm, [data-bms-lead-form]')) buildSummary(f);
  }, true);

  if (document.readyState === 'loading' && document.addEventListener) {
    document.addEventListener('DOMContentLoaded', function () { fillContactForm(); });
  } else {
    fillContactForm();
  }
})();
